export default "__VITE_ASSET__CbjM6Fmm__"